const VIDEO_PRICING_MODEL = {
    CPCV: 'CPCV',
    VCPM: 'VCPM',
    CPM: 'CPM',
    CPM_EXTERNAL: 'CPM_EXTERNAL',
};

export default VIDEO_PRICING_MODEL;
